import {concat, of} from 'rxjs';
import {COUNTRIES} from '../constants/AppConstants';
import * as ErrorConstants from '../constants/ErrorConstants';
import * as SecuritySSOConstants from '../constants/SecuritySSOConstants';
import * as LoginActions from '../actions/LoginActions';
import {ERROR_GENERAL_ACTION} from '../actions/UIActions';

export const mapLoanApplication = (item) => {
    return {
        hash: item.hash,
        applicantCompleteName: item.applicantCompleteName,
        bankApplicationId: item.bankApplicationId,
        brand: item.brand,
        model: item.model,
        year: item.year,
        updatedAt: item.updatedAt ? item.updatedAt.displayValue : '',
        vehiclePrice: item.vehiclePrice ? item.vehiclePrice.displayValue : '',
        stage: item.stage ? item.stage.value : '',
        token: item.token
    };
};

export const getApiHeader = (state, isSecure = true) => {
    const header = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };

    if (isSecure) {
        header['Authorization'] = `Bearer ${state.profile.accessToken}`;
        header['clientId'] = COUNTRIES[state.countrySelector.countrySelected].securityClientId;
    }
    return header;
};

export const getSecurityApiHeader = (state) => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'refresh-token': state.profile.refreshToken,
        'access-token': state.profile.accessToken,
        domain: SecuritySSOConstants.getKCClient(state.countrySelector.countrySelected)
    };
};

// Siempre devuelve una lista de errors el RetryUtil
export const processApiError = errorActions => (errors) => {
    let isSessionExpiredError = false;
    const errorMapped = (Array.isArray(errors) ? errors : []).map(((error) => {
        switch (error) {
            case ErrorConstants.UNDEFINED_AUTHORIZATION_ERROR:
            case ErrorConstants.SESSION_EXPIRED_ERROR:
                isSessionExpiredError = true;
                return LoginActions.SESSION_EXPIRED_ACTION.action();
            default:
                undefined;
        }
    })).filter(error => error);

    const errorFiltered = isSessionExpiredError ?
        errorActions.filter(error => error.type !== ERROR_GENERAL_ACTION.name) : errorActions;

    return concat(...errorFiltered.concat(errorMapped).map(error => of(error)));

};